<div class="container">
  <div class="row">
    <div class="col-md-3 yc-panel primary mobile-h-150 icon">
      <img src="./assets/img/placeholders/grants-icon-placeholder.svg"
        [alt]="'GLOBAL:textGrantsConnectIcon' | ycI18n: 'GrantsConnect icon'">
    </div>
    <div class="col-md-9 yc-panel content">
      <h1 class="yc-header">
        <yc-i18n
          key="GLOBAL:hdrYouHaveBeenLoggedOutOfGrantsConnect"
          defaultValue="You have been logged out of GrantsConnect">
        </yc-i18n>
      </h1>
      <p>
        <a *ngIf="prefix" [routerLink]="['../auth/signin']">
          <yc-i18n key="GLOBAL:linkLogBackIn" defaultValue="Log back in to GrantsConnect"></yc-i18n>
        </a>
        <ng-container *ngIf="!prefix">
          <yc-i18n
            key="GLOBAL:textGoodIdeaToCloseWindows"
            defaultValue="It's a good idea to close all GrantsConnect windows">
          </yc-i18n>
        </ng-container>
      </p>
    </div>
  </div>
</div>
